import React, { Component } from 'react';
import './css/bootstrap.min.css'
import './Header.css'
import { Navbar, Badge, NavItem, Nav, NavDropdown, MenuItem} from 'react-bootstrap';
import { LinkContainer } from "react-router-bootstrap";
import logo from './logo-bg-transparent.png'

class Header extends Component {

  render() {
    return (
  <React.Fragment>
  <Navbar className="navbar-nlc" fluid collapseOnSelect>
    <Navbar.Header>
      <LinkContainer to="/">
        <img src={logo} alt="NaleyCards Greeting Cards" width="180" />
      </LinkContainer>
      <Navbar.Toggle />
    </Navbar.Header>
      {this.props.savedCount > 0 && (
      <Nav pullRight>
        <LinkContainer to="/orders">
          <NavItem>
            &nbsp;&nbsp;Saved <Badge>{this.props.savedCount}</Badge>
          </NavItem>
        </LinkContainer>
      </Nav>
      )}
    <Navbar.Collapse>
      <Nav pullRight>
      <NavDropdown title="Cards" id="basic-nav-dropdown">
       <LinkContainer to="/cny-cards">
          <MenuItem>Chinese New Year</MenuItem>
       </LinkContainer>
       <LinkContainer to="/christmas-cards">
          <MenuItem>Christmas</MenuItem>
        </LinkContainer>
        <LinkContainer to="/social-distancing-cards">
          <MenuItem>Social Distancing</MenuItem>
        </LinkContainer>
        <LinkContainer to="/birthday-cards">
          <MenuItem>Birthday</MenuItem>
        </LinkContainer>
        <LinkContainer to="/中秋节-Mid-autumn-festival-cards">
          <MenuItem>中秋节</MenuItem>
        </LinkContainer>
        <LinkContainer to="/fathers-day-cards">
          <MenuItem>Father's Day</MenuItem>
        </LinkContainer>
        <LinkContainer to="/teachers-day-cards">
          <MenuItem>Teachers' Day</MenuItem>
        </LinkContainer>
        <LinkContainer to="/love-cards">
          <MenuItem>Love &amp; Valentine's Day</MenuItem>
        </LinkContainer>
        <LinkContainer to="/hari-raya-cards">
          <MenuItem>Hari Raya</MenuItem>
        </LinkContainer>
        <LinkContainer to="/mothers-day-cards">
          <MenuItem>Mother's Day</MenuItem>
        </LinkContainer>
        <LinkContainer to="/thank-you-cards">
          <MenuItem>Thank You</MenuItem>
        </LinkContainer>
        <LinkContainer to="/new-baby-cards">
          <MenuItem>New Baby</MenuItem>
        </LinkContainer>
        <LinkContainer to="/category/550">
          <MenuItem>Friendship</MenuItem>
        </LinkContainer>
        <LinkContainer to="/category/900">
          <MenuItem>Congratulations</MenuItem>
        </LinkContainer>
        <LinkContainer to="/farewell-cards">
          <MenuItem>Farewell</MenuItem>
        </LinkContainer>
        <LinkContainer to="/category/670">
          <MenuItem>Get Well Soon</MenuItem>
        </LinkContainer>
        <LinkContainer to="/category/600">
          <MenuItem>Sympathy</MenuItem>
        </LinkContainer>
        <LinkContainer to="/category/650">
          <MenuItem>Sorry</MenuItem>
        </LinkContainer>
        <MenuItem divider />
        <LinkContainer to="/cards">
          <MenuItem>All Cards</MenuItem>
        </LinkContainer>
      </NavDropdown>
      <LinkContainer to="/purchases">
        <NavItem>
          Purchased
        </NavItem>
      </LinkContainer>
      <LinkContainer to="/faq">
        <NavItem>
          FAQ
        </NavItem>
      </LinkContainer>
      <LinkContainer to="/contacts">
        <NavItem>
          Contacts&nbsp;
        </NavItem>
      </LinkContainer>
      </Nav>
    </Navbar.Collapse>
  </Navbar>
  {/*<div style={{height: 55 + 'px'}}> </div>*/}
  {this.props.subject != null && (
  <div className="subject">{this.props.subject}</div>
  )}
  </React.Fragment>
    );
  }
}

export default Header;
